// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".radio-boxs[data-v-0711b554] {\n  margin-left: 36px;\n  margin-bottom: -10px;\n}\n.title-tips[data-v-0711b554] {\n  font-size: 12px;\n  color: #333;\n}\n.title-tips span[data-v-0711b554] {\n  color: #999;\n}", ""]);
// Exports
module.exports = exports;
